// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

var invalidCNPJs = [
  "00000000000000",
  "11111111111111",
  "22222222222222",
  "33333333333333",
  "44444444444444",
  "55555555555555",
  "66666666666666",
  "77777777777777",
  "88888888888888",
  "99999999999999"
];

function isNumeric(str) {
  return /^\d*$/.test(str);
}

function isUppercaseAlphanumeric(str) {
  return /^[A-Z0-9]*$/.test(str);
}

function isCNPJValidFormat(cnpj) {
  var base = cnpj.slice(0, 12);
  var checkDigits = cnpj.slice(12, 14);
  if (isUppercaseAlphanumeric(base)) {
    return isNumeric(checkDigits);
  } else {
    return false;
  }
}

function charToValue(ch) {
  var code = ch.charCodeAt(0) | 0;
  if (code >= 48 && code <= 57 || code >= 65 && code <= 90) {
    return code - 48 | 0;
  } else {
    return 0;
  }
}

function calculateCheckDigit(values, weights) {
  var sum = Core__Array.reduceWithIndex(values, 0, (function (acc, v, i) {
          return acc + Math.imul(v, Core__Option.getOr(weights[i], 0)) | 0;
        }));
  var remainder = sum % 11;
  if (remainder < 2) {
    return 0;
  } else {
    return 11 - remainder | 0;
  }
}

function validateCNPJ(cnpj) {
  var chars = cnpj.split("");
  var base = chars.slice(0, 12).map(charToValue);
  var firstDigit = calculateCheckDigit(base, [
        5,
        4,
        3,
        2,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2
      ]);
  var secondDigit = calculateCheckDigit(Belt_Array.concatMany([
            base,
            [firstDigit]
          ]), [
        6,
        5,
        4,
        3,
        2,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2
      ]);
  var checkDigit1 = Core__Option.getOr(Core__Option.map(chars[12], charToValue), -1);
  var checkDigit2 = Core__Option.getOr(Core__Option.map(chars[13], charToValue), -1);
  if (firstDigit === checkDigit1) {
    return secondDigit === checkDigit2;
  } else {
    return false;
  }
}

function isValidCNPJ(cnpj) {
  if (cnpj.length !== 14 || invalidCNPJs.includes(cnpj) || !isCNPJValidFormat(cnpj)) {
    return false;
  } else {
    return validateCNPJ(cnpj);
  }
}

var cnpjLength = 14;

export {
  cnpjLength ,
  invalidCNPJs ,
  isNumeric ,
  isUppercaseAlphanumeric ,
  isCNPJValidFormat ,
  charToValue ,
  calculateCheckDigit ,
  validateCNPJ ,
  isValidCNPJ ,
}
/* No side effect */
